import { Input, ButtonRoundedSmall, ButtonWithoutBackground } from '@comeon/ui';
import styled, { css } from 'styled-components';
import { getZindexByType } from '~/utils/style-utils.ts';

export const Header = styled.div`
	position: absolute;
	left: 5px;
	top: 5px;
	margin: 0;
	button {
		color: rgba(var(--qd-modal-contrast-text), 1);
		svg.icon--sprite {
			fill: rgba(var(--qd-modal-contrast-text), 1);
		}
	}
`;

export const StyledCVVInput = styled.div`
	position: relative;
	margin-top: 30px;
	input {
		margin-bottom: 5px;
		padding-right: 40px;
	}
	button {
		position: absolute;
		top: 20px;
		right: 10px;
		z-index: 123;
	}
`;

export const StyledToggle = styled.div`
	display: flex;
	align-items: baseline;
	padding-bottom: 10px;
	padding-top: 15px;
`;

export const PaypalModalWrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
`;

export const StyledAmountInput = styled(Input)`
	text-align: center;
	font-weight: bold;
	font-size: 30px;
	min-height: 64px;
	padding-bottom: 14px;
	margin-bottom: 5px;
	font: var(--h1);
	background-color: var(--quick-deposit-amount-input-bg);
`;

export const InfoText = styled.small`
	max-width: 220px;
	max-width: fit-content;
	font: var(--label-regular);
	min-height: 10px;
`;

export const Spinner = styled.div`
	z-index: ${getZindexByType('notification') + 5};
`;

export const LogoContainer = styled.div`
	margin-right: 10px;
	padding: 0 3px;
	background: #fff;
	border-radius: 2px;
	svg {
		width: 70px;
		&.payment_method_std_visa,
		&.payment_method_omnimatrix {
			height: 30px;
			padding: 5px 0;
		}
	}
`;

export const NewQDIconContainer = styled.div`
	color: inherit;
	height: fit-content;
	max-height: 30px;
	max-width: 75px;
	width: fit-content;

	svg {
		max-height: 30px;
		width: 100%;

		&.payment_method_std_visa {
			max-height: 25px;
			padding: 3px 0;
		}

		&.payment_method_klarna {
			max-width: 70px;
		}

		&.payment_method_gluepay {
			min-width: 70px;
		}

		&.payment_method_std_mastercard {
			max-width: 50px;
		}

		&.payment_method_paypal {
			width: 75px;
		}
	}
`;

export const IconContainer = styled.div`
	color: inherit;
	margin-left: 5px;
	svg {
		max-height: 30px;
		&.payment_method_std_visa {
			max-height: 25px;
			padding: 3px 0;
		}
		&.payment_method_klarna {
			max-width: 70px;
		}

		&.payment_method_gluepay {
			min-width: 70px;
		}
		&.payment_method_std_mastercard {
			padding-left: 7px;
		}
		&.payment_method_paypal {
			width: 75px;
		}
	}
`;

export const PaymentButtonSecondary = styled(ButtonRoundedSmall)`
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 42px;

	span {
		margin: auto 6px;
	}

	svg,
	svg * {
		fill: ${({ disabled }) =>
			disabled ? `var(--button-disabled-text)` : 'var(--button-primary-text,rgba(var(--base-02),1))'};
	}
`;

export const RoundedButtonSecondary = styled(ButtonRoundedSmall)`
	color: rgba(var(--qd-modal-contrast-text), 1);
	background: transparent;
	min-height: 35px;
	border: 1px solid ${props => (props.disabled ? 'transparent' : 'var(--button-primary-bg, rgba(var(--primary), 1))')};
`;

export const MethodsCollapse = styled.div`
	background: var(--quick-deposit-methods-collapse-bg);
	width: 90%;
	transition: all 0.3s ease-out;
	overflow: hidden;
	border-radius: 6px;
	${props =>
		props.toggle
			? css`
					height: ${props.items * 42}px;
					visibility: visible;
					margin-bottom: 12px;
				`
			: css`
					height: 0;
					visibility: hidden;
				`};
	.link-list__item-link {
		padding: 0 12px;
		height: 34px;
		overflow: hidden;
		min-height: initial;
		margin: 6px 0px;
		cursor: pointer;
	}
`;

export const MethodsCollapseTitle = styled(ButtonWithoutBackground)`
	display: flex;
	font: var(--label-bold);
	justify-content: center;
	padding-bottom: 8px;
	color: rgba(var(--qd-modal-contrast-text), 1);

	span {
		color: inherit;

		&.icon-wrapper {
			margin-left: 12px;
		}
	}

	&:disabled {
		background-color: inherit;
		color: inherit;
		opacity: 0.7;
	}
`;

export const AccountInfoName = styled.span`
	max-width: 100px;
	overflow: hidden;
	white-space: nowrap;
	display: inline-block;
	text-overflow: ellipsis;
`;

export const MoreMethodsLink = styled.li`
	justify-content: center;
	span {
		text-decoration: underline;
		color: rgba(var(--qd-modal-contrast-text), 1);
	}
`;

export const Logo = styled.div`
	height: 30px;
	width: 75px;
	overflow: hidden;
	background-color: rgba(var(--base-01), 1);
	border-radius: 3px;
	margin-right: 10px;
`;
